import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/rallly/apps/web/src/app/[locale]/(admin)/dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer","PageHeader","PageIcon","PageTitle","PageContent"] */ "/srv/rallly/apps/web/src/app/components/page-layout.tsx");
